import * as Yup from 'yup'
import Button from '../../../components/button/Button'
import './AreaWiseInquiryReport.scss'
import { ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import { ErrorMessage } from 'formik'
import Calendar from '../../../components/calendar/Calendar'
import { Form, Formik } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { useDispatch, useSelector } from 'react-redux'
import {
  addIdKeyToObject,
  convertDateFormatCalendar,
  exportAreaWiseInquiryReport,
  generateDropdownOptions,
} from '../../../utility/genricFunction'
import dayjs from 'dayjs'
import ReportDataTable from '../../../components/report-table/ReportDataTable'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { Column } from 'primereact/column'
import { getAreaWiseInquiryReport, getCourseFromBranch } from '../../../store/builders/reports/reports.builder'
import PrintIcon from '@mui/icons-material/Print'
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload'
import { useReactToPrint } from 'react-to-print'
import Loader from '../../../components/loader/Loader'


const AreaWiseInquiryReport = () => {
  const [showTable, setShowTable] = useState(false)

  const dispatch = useDispatch()
  const branches = useSelector((state) => state?.branch?.branchTableData)
  const { courseByBranchData: courses, areaWiseInquiryReport,loading,pageDropDownLoading } = useSelector((state) => state?.reports)
  const userRole = useSelector((store) => store?.auth?.user?.result?.userData?.roleName)
  const branchId = useSelector((store) => store?.auth?.user?.result?.userData?.branchId)

  const [initialValues] = useState({
    fromDate: '',
    toDate: '',
    branch: '',
    course: '',
  })

  useEffect(() => {
    if (userRole == 'branch') {
      dispatch(getCourseFromBranch(branchId))
    }
  })

  //   useEffect(() => {
  //     dispatch(getBranch('active'))
  //     dispatch(getFaculty())
  //   }, [dispatch])

  const courseOption = useMemo(() => generateDropdownOptions(courses, 'courseName', 'courseId'), [courses])
  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])

  const printRef = useRef()

  const handleDownloadPfd = useReactToPrint({
    content: () => printRef.current,
});

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.REPORTS.AREA_WISE_INQUIRY_REPORT.LABEL_AREA_WISE_INQUIRY_REPORT,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.REPORTS.AREA_WISE_INQUIRY_REPORT.LABEL_AREA_WISE_INQUIRY_REPORT,
      link: ROUTES_PATH.AREA_WISE_INQUIRY_REPORT,
    },
  ]


  const columns = [
    {
      field: 'id',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>#</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '0.5rem' },
    },
    {
      field: 'permanent_city',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>City</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },
    {
      field: 'permanent_area',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Area</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
    },

    /////////////telephonic
    {
      field: 'telephonic_alive_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Alive</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
    {
      field: 'telephonic_dead_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Dead</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },

    {
      field: 'telephonic_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Total</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
   /////////////////t2w
   {
    field: 't2w_alive_count',
    header: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <p>Alive</p>
      </div>
    ),
    filter: false,
    filterDisplay: 'row',
    style: { minWidth: '3rem' },
  },
  {
    field: 't2w_dead_count',
    header: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <p>Dead</p>
      </div>
    ),
    filter: false,
    filterDisplay: 'row',
    style: { minWidth: '3rem' },
  },

  {
    field: 't2w_count',
    header: (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <p>Total</p>
      </div>
    ),
    filter: false,
    filterDisplay: 'row',
    style: { minWidth: '3rem' },
  },
    ///////// walkin
    {
      field: 'walkin_alive_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Alive</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
    {
      field: 'walkin_dead_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Dead</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
    {
      field: 'walkin_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Total</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },

    //////// Enrollment
    {
      field: 'enroll_alive_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Alive</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
    {
      field: 'enroll_dead_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Dead</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
    {
      field: 'enroll_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Total</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
    //totel
    {
      field: 'total_count',
      header: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <p>Total</p>
        </div>
      ),
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '3rem' },
    },
  ]

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header='#' rowSpan={2} />
        <Column header='City' rowSpan={2} />
        <Column header='Area' rowSpan={2} />
        <Column header='Telephonic' colSpan={3} />
        <Column header='T2W' colSpan={3} />
        <Column header='Walkin' colSpan={3} />
        <Column header='Enrollment' colSpan={3} />
        <Column header='Total' rowSpan={2} />
      </Row>
      <Row>
        <Column header='Alive' />
        <Column header='Dead' />
        <Column header='Total' />

        <Column header='Alive' />
        <Column header='Dead' />
        <Column header='Total' />

        <Column header='Alive' />
        <Column header='Dead' />
        <Column header='Total' />

        <Column header='Alive' />
        <Column header='Dead' />
        <Column header='Total' />


      </Row>
    </ColumnGroup>
  )

  const handleBranchDropDownChange = (value, setFieldValue) => {
    setFieldValue('branch', value)
    dispatch(getCourseFromBranch(value))
  }

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date().required('From Date is required').typeError('Invalid Date'),
    toDate: Yup.date()
      .required('To Date is required')
      .typeError('Invalid Date')
      .min(Yup.ref('fromDate'), 'To Date cannot be before From Date'),
    branch: Yup.string().required('Branch is required'),
    course: Yup.string().required('Course is required'),
  })

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer='Total' colSpan={3} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.telephonic_alive_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.telephonic_dead_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.telephonic_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.t2w_alive_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.t2w_dead_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.t2w_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.walkin_alive_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.walkin_dead_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.walkin_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.enroll_alive_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.enroll_dead_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.enroll_count} className='table-total-row' />
        <Column footer={areaWiseInquiryReport?.totalCounts?.total_count} className='table-total-row' />
      </Row>
    </ColumnGroup>
  )

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> && <div className='areawise-inquiry-report-wrapper'>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(value) => {
          setShowTable(true)
          const data = {
            startDate: dayjs(value.fromDate).format('YYYY-MM-DD'),
            endDate: dayjs(value.toDate).format('YYYY-MM-DD'),
            branchId: value.branch,
            courseId: value.course,
          }
          dispatch(getAreaWiseInquiryReport(data))
        }}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <div className='areawise-inquiry-report-header'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
            <div className='areawise-inquiry-report-main-div'>
              <div className='areawise-inquiry-report-input-fields'>
                <Calendar
                  label='From Date'
                  name='fromDate'
                  required={true}
                  width={'25%'}
                  onChange={(values) => {
                    setFieldValue('fromDate', convertDateFormatCalendar(values))
                  }}
                />
                <Calendar
                  label='To Date'
                  name='toDate'
                  required={true}
                  width={'25%'}
                  onChange={(values) => setFieldValue('toDate', convertDateFormatCalendar(values))}
                />
                <div className='areawise-inquiry-report-dropdown'>
                  <label htmlFor=''>
                    Branch<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    className={'facultyForm-dropdown'}
                    name={'branch'}
                    placeholder={'Select Branch'}
                    options={branchOption}
                    selectedValue={values.branch}
                    onChange={(e) => {
                      handleBranchDropDownChange(e.target.value, setFieldValue)
                    }}
                  />
                  <ErrorMessage name='stateId' component='div' className='error-msg' />
                </div>
                <div className='areawise-inquiry-report-dropdown'>
                  <label htmlFor=''>
                    Course<span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    loading={pageDropDownLoading}
                    options={courseOption}
                    selectedValue={values.course}
                    className={'facultyForm-dropdown'}
                    name={'course'}
                    placeholder={'Select Faculty'}
                    onChange={handleChange}
                  />
                  <ErrorMessage name='stateId' component='div' className='error-msg' />
                </div>
              </div>

              <div className='submit-btn-wrapper'>
                <Button customClassName={'tt-report-btn-submit'}>Submit</Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {showTable && (
        <div className='areawise-inquiry-report-table-div'>
          <div className='export-option-wrapper'>
            <div className='pdf-excel-export'>
              <Button
                text={'Export'}
                type={'button'}
                onClick={() =>
                    exportAreaWiseInquiryReport(areaWiseInquiryReport)
                }
              >
                <SimCardDownloadIcon />
              </Button>
              <Button text={'Export'} type={'button'} onClick={handleDownloadPfd}>
                <PrintIcon />
              </Button>
            </div>
          </div>

          <div className='printable-component' ref={printRef}>
          <ReportDataTable
            columns={columns}
            headerColumnGroup={headerGroup}
            footerColumnGroup={footerGroup}
            value={addIdKeyToObject(areaWiseInquiryReport.inquiry)}
          />
          </div>

        </div>
      )}
    </div>}
    </>
  )
}

export default AreaWiseInquiryReport
